module.exports = {"history":"Historial de trabajo","improving":"Consultor Senior","improving-duration":"Nov 2017 - Presente","aver":"Ingeniero Front-end","aver-duration":"Julio de 2017 a Noviembre de 2017","capitalone":"Ingeniero de programación superior","capitalone-duration":"Julio de 2014 - Mayo de 2017"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/es/work.json
// module id = 78
// module chunks = 0